import React from "react";
import { ContextStore } from "../../../../../../../../react-core/Flux/Variables";
import { Lightbox } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { ToggleButtonTwoOptions } from "../../../../../../../../react-core/Html/ToggleButtonTwoOptions";
import { AccountRoleActorCategory } from "../../../../../../../../Wrap/Constants/Enums/AccountRoleActorCategory";
import { HierarchyLevelName } from "../../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { RoleStatus } from "../../../../../../../../Wrap/Constants/Enums/RoleStatus";
import { RoleType } from "../../../../../../../../Wrap/Constants/Enums/RoleType";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { AccountRole } from "../../../../../../../../Wrap/Models/Domains/Account/AccountRole";
import { InterestedParty } from "../../../../../../../../Wrap/Models/Models/Customer/InterestedParty";
import { HierarchyIdHelper } from "../../../../../../../Shared/Common/HierarchyIdHelper";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import { Table } from "../../../../../../../Shared/Table/Table";
import AriaTooltip from "../../../../../../../Shared/Tooltip/AriaTooltip";
import { Navigator } from "../../../../../../../Shared/Wizards/Entities/Navigator";
import { Action } from "../../../../../../Actions/Action";
import { UserStore } from "../../../../../../Stroes/Variable";
import { Urls } from "../../../../../../Urls";
import { AccountInfoAction } from "../Action/AccountInfoAction";
import { roleTypeMap } from "../../../../ClientRecord/Resource/Contents";
import { PortfolioDashboardStore } from "../../../Store/Variable";
import { portfolioDashboardRolesAction } from "../Action/Action";

interface IInterestedPartiesProps {
    customerId: number;
    hierarchyIds: Array<string>;
    isOrganisation: boolean;
    userIsAdviser?: boolean;
    clAccountId: string;
    showAddInterestedParty: boolean;
    hasReadWriteAccessToAdviser: boolean;
}

export const InterestedParties = (props: IInterestedPartiesProps) => {
    const [data, setData] = React.useState(null);
    const [roles, setRoles] = React.useState<AccountRole[]>([]);
    const [showDeleteLightBox, setShowDeleteLightBox] = React.useState(false);
    const [deleteInterestedParty, setDeleteInterestedParty] = React.useState({
        actorId: null,
        accountHierarchyId: null,
        roleType: null,
    });
    const [isLoading, setIsLoading] = React.useState(false);
    const [isEditOnlineAccess, setIsEditOnlineAccess] = React.useState(false);
    const [onlineAccessData, setOnlineAccessData] = React.useState<InterestedParty[]>(null);

    React.useEffect(() => {
        setData(null);
        if (props?.hierarchyIds && props?.hierarchyIds.length > 0) {
            setIsLoading(true);
            portfolioDashboardRolesAction.getInterestedPartiesByCustomer(props.customerId, (res) => {
                const interestedParties = props.userIsAdviser
                    ? res.filter(
                          (x) => x.AccountRoleType != RoleType.LetterOfAuthority && x?.ActorId != props.customerId
                      )
                    : res.filter((x) => x?.ActorId != props.customerId);
                setData(interestedParties);
                setIsLoading(false);
            });
        }
    }, [props.hierarchyIds]);

    React.useEffect(() => {
        if (props?.hierarchyIds?.length > 0) {
            props.hierarchyIds.forEach((hierarchyId) => {
                Action.getAccountRoles(hierarchyId, (res: AccountRole[]) => {
                    setRoles(
                        res.filter(
                            (ele) => ele.Role == RoleType.AdditionalBeneficiary && ele.RoleStatus == RoleStatus.Active
                        )
                    );
                });
            });
        }
    }, []);

    const mapBenificiaryToInterestedParty = (member: AccountRole): InterestedParty => {
        return {
            GivenName: member?.Customer?.PersonalDetails?.Name?.Given,
            FamilyName: member?.Customer?.PersonalDetails?.Name?.Family,
            ClAccountId: props.clAccountId,
            AccountRoleType: member.Role,
            ClientPortalAccess: null,
            ActorCategory: AccountRoleActorCategory.Associate,
        };
    };

    const beneficiaries = (roles || []).map((ele) => {
        return mapBenificiaryToInterestedParty(ele);
    });

    const doDelete = (data: any) => {
        setIsLoading(true);
        AccountInfoAction.deleteInterestedParty(data?.actorId, data?.accountHierarchyId, data?.roleType, (res) => {
            portfolioDashboardRolesAction.getInterestedPartiesByCustomer(props.customerId, (res) => {
                const interestedParties = props.userIsAdviser
                    ? res.filter(
                          (x) => x.AccountRoleType != RoleType.LetterOfAuthority && x?.ActorId != props.customerId
                      )
                    : res.filter((x) => x?.ActorId != props.customerId);
                setData(interestedParties);
                setIsLoading(false);
            });
        });
    };

    const renderTable = () => {
        if (isLoading) {
            return <PartLoading isLoading={true} />;
        } else {
            return (
                <Table
                    data={(data || []).concat(beneficiaries)}
                    col={[
                        {
                            title: "Name",
                            key: "GivenName",
                            render: (data, row, index) => {
                                return row?.GivenName + " " + row?.FamilyName;
                            },
                        },
                        {
                            title: "Account number",
                            key: "ClAccountId",
                        },
                        {
                            title: "Account role",
                            key: "AccountRoleType",
                            render: (data) => {
                                return roleTypeMap[data];
                            },
                        },
                        {
                            title:
                                !UserStore.getUserInfo()?.IsReadOnly && props.hasReadWriteAccessToAdviser == true ? (
                                    <p className="mb-0">
                                        Online access
                                        <span>
                                            <button
                                                className="edit-circle-icon-button label-sr-only"
                                                onClick={() => {
                                                    setIsEditOnlineAccess(!isEditOnlineAccess);
                                                    setOnlineAccessData(
                                                        !isEditOnlineAccess
                                                            ? JSON.parse(
                                                                  JSON.stringify((data || []).concat(beneficiaries))
                                                              )
                                                            : null
                                                    );
                                                }}
                                            >
                                                <span className="icon" aria-hidden="true"></span>
                                                <span className="text">Edit online access</span>
                                            </button>
                                        </span>
                                    </p>
                                ) : (
                                    <p className="mb-0">Online access</p>
                                ),
                            key: "ClientPortalAccess",
                            render: (data, row: InterestedParty, index) => {
                                if (
                                    row.ActorCategory == AccountRoleActorCategory.Associate ||
                                    row.AccountRoleType == RoleType.ThirdPartyPayer ||
                                    row.AccountRoleType == RoleType.LifeAssured
                                )
                                    {return "";}
                                if (isEditOnlineAccess) {
                                    return (
                                        <ToggleButtonTwoOptions
                                            optionOne={"No"}
                                            optionTwo={"Yes"}
                                            value={onlineAccessData?.[index]?.ClientPortalAccess}
                                            onChange={(v) => {
                                                const _data = onlineAccessData?.concat();
                                                _data[index].ClientPortalAccess = v;
                                                setOnlineAccessData(_data);
                                            }}
                                        />
                                    );
                                }
                                return data ? "Yes" : "No";
                            },
                        },
                        !UserStore.getUserInfo()?.IsReadOnly && props.hasReadWriteAccessToAdviser == true
                            ? {
                                  title: "Edit",
                                  key: "",
                                  render: (data, row: InterestedParty) => {
                                      if (
                                          !ContextStore.getContext()?.isAdminUser &&
                                          ![
                                              RoleType.Beneficiary,
                                              RoleType.AccountAccess,
                                              RoleType.AccountAccessLegacy,
                                              RoleType.AdditionalBeneficiary,
                                          ].includes(row.AccountRoleType)
                                      ) {
                                          return null;
                                      }
                                      return (
                                          <button
                                              className="edit-button label-sr-only"
                                              title="Edit"
                                              onClick={() => {
                                                  if (row?.AccountRoleType == RoleType.AdditionalBeneficiary) {
                                                      Navigator.navigateTo(
                                                          Urls.get().main.PortfolioDashboard({
                                                              hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                                                  HierarchyLevelName.Customer,
                                                                  props.customerId
                                                              ),
                                                          }).TrustServicing
                                                      );
                                                  } else if (row?.ActorCategory == AccountRoleActorCategory.Customer) {
                                                      Navigator.navigateTo(
                                                          Urls.get().main.PortfolioDashboard({
                                                              hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                                                  HierarchyLevelName.Customer,
                                                                  row?.ActorId
                                                              ),
                                                          }).personalDetail
                                                      );
                                                  } else {
                                                      Navigator.navigateTo(Urls.get().InterestedParties, {
                                                          scrollAfterNavigating: true,
                                                          queryParamsObject: {
                                                              customerid: props.customerId,
                                                              ipid: row?.ActorId,
                                                              accountrole: row?.AccountRoleType,
                                                          },
                                                      });
                                                  }
                                              }}
                                          >
                                              <span className="icon" aria-hidden="true"></span>
                                          </button>
                                      );
                                  },
                              }
                            : null,
                        !UserStore.getUserInfo()?.IsReadOnly && props.hasReadWriteAccessToAdviser == true
                            ? {
                                  title: "Remove",
                                  key: "",
                                  render: (item, row: InterestedParty) => {
                                      if (
                                          !ContextStore.getContext()?.isAdminUser &&
                                          ![
                                              RoleType.Beneficiary,
                                              RoleType.AccountAccess,
                                              RoleType.AccountAccessLegacy,
                                              RoleType.AdditionalBeneficiary,
                                          ].includes(row.AccountRoleType)
                                      ) {
                                          return null;
                                      } else if (
                                          row.AccountRoleType == RoleType.ControllingPerson &&
                                          data.filter((x) => x.AccountRoleType == RoleType.ControllingPerson)?.length ==
                                              1
                                      ) {
                                          return null;
                                      } else
                                          {return (
                                              <button
                                                  className="remove-button label-sr-only"
                                                  title="Delete"
                                                  onClick={() => {
                                                      if (row?.AccountRoleType == RoleType.AdditionalBeneficiary) {
                                                          Navigator.navigateTo(
                                                              Urls.get().main.PortfolioDashboard({
                                                                  hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                                                      HierarchyLevelName.Customer,
                                                                      props.customerId
                                                                  ),
                                                              }).TrustServicing
                                                          );
                                                      } else {
                                                          setShowDeleteLightBox(true);
                                                          setDeleteInterestedParty({
                                                              actorId: row?.ActorId,
                                                              accountHierarchyId: row?.HierarchyId,
                                                              roleType: row?.AccountRoleType,
                                                          });
                                                      }
                                                  }}
                                              >
                                                  <span className="icon" aria-hidden="true"></span>
                                              </button>
                                          );}
                                  },
                              }
                            : null,
                    ].filter((x) => x != null)}
                    showEmptyMsg
                />
            );
        }
    };

    return (
        <div>
            <div className="flex-wrap">
                <h3>Interested parties</h3>
                {props.isOrganisation && (
                    <AriaTooltip
                        cssWrapper="is-info-icon ml-6"
                        showCloseButton={true}
                        title="More information on interested parties"
                    >
                        Beneficiary only role will display in this table.
                    </AriaTooltip>
                )}
                <AriaTooltip
                    cssWrapper="is-info-icon ml-6"
                    showCloseButton={true}
                    title="More information on interested parties"
                >
                    Please note this doesn't include consolidated accounts, those will need to be searched for
                    separately
                </AriaTooltip>
            </div>
            {renderTable()}
            {isEditOnlineAccess && (
                <div className="row mt-10">
                    <div className="col-12">
                        <button
                            className="btn primary mr-10"
                            onClick={() => {
                                onlineAccessData.forEach((member) => {
                                    const notNeedUpdate =
                                        member.ActorCategory == AccountRoleActorCategory.Associate ||
                                        member.AccountRoleType == RoleType.ThirdPartyPayer ||
                                        member.AccountRoleType == RoleType.LifeAssured;
                                    if (!notNeedUpdate) {
                                        portfolioDashboardRolesAction.updateClientAccess({
                                            CustomerId: member.ActorId,
                                            HierarchyId: PortfolioDashboardStore.getData()?.find(
                                                (acc) => acc.HeadClAccountId == member.ClAccountId
                                            )?.HierarchyId,
                                            RoleType: member.AccountRoleType,
                                            IsClientAccess: member.ClientPortalAccess,
                                        });
                                    }
                                });
                                setIsEditOnlineAccess(false);
                                setData(
                                    onlineAccessData.filter(
                                        (ele) => ele.AccountRoleType != RoleType.AdditionalBeneficiary
                                    )
                                );
                            }}
                        >
                            Save
                        </button>
                        <button
                            className="btn primary mr-10"
                            onClick={() => {
                                setIsEditOnlineAccess(false);
                                setOnlineAccessData(null);
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            )}
            {checkPermission(UserClaim.AdviserPortalCustomerPartialAccessCanView) &&
                props.hasReadWriteAccessToAdviser == true &&
                !UserStore.getUserInfo()?.IsReadOnly && (
                    <div className="page-actions">
                        <div className="action-primary">
                            {props.showAddInterestedParty && (
                                <button
                                    className="btn secondary"
                                    onClick={() => {
                                        Navigator.navigateTo(Urls.get().InterestedParties, {
                                            scrollAfterNavigating: true,
                                            queryParamsObject: {
                                                customerid: props.customerId,
                                            },
                                        });
                                    }}
                                >
                                    <span className="text">Add interested party</span>
                                </button>
                            )}
                        </div>
                    </div>
                )}

            <span>To check all of the access levels of your clients, use the </span>
            {!checkPermission(UserClaim.AdviserPortalDluFindUsersCanView) ? (
                <a
                    href="javascript:void(0);"
                    className="hyperlink"
                    onClick={() => window.location.assign(`/admin/users/findusers.aspx`)}
                >
                    Find User
                </a>
            ) : (
                <span>Find User</span>
            )}
            <span> page</span>
            {showDeleteLightBox && (
                <Lightbox
                    cssWrapper="is-default-lightbox is-delete-lightbox"
                    show={true}
                    onClose={() => setShowDeleteLightBox(false)}
                    title="Delete filter"
                >
                                   <p>Are you sure you want to delete?</p>
                                   
                    <div className="row row-center">
                                  
                        <div className="col-auto">
                            <button
                                type="button"
                                className="btn secondary"
                                onClick={() => setShowDeleteLightBox(false)}
                            >
                                Cancel
                            </button>
                                               
                        </div>
                        <div className="col-auto">
                                                   
                            <button
                                type="button"
                                className="btn primary"
                                onClick={() => {
                                    doDelete(deleteInterestedParty);
                                    setShowDeleteLightBox(false);
                                }}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </Lightbox>
            )}
        </div>
    );
};
